import React from 'react';
// Import Global Components
import { Loader, Title } from 'shared-components';
// Import Component Styles
import { ConfirmTransferModal, ProgressContainer, BatchStatus, StatusItem, ResultsList, ResultItem } from './styles';

export default function({ batchProgress }) {
  const { total, submitted, successful, failed, inProgress, results } = batchProgress || {};

  // If not in batch mode, show simple loader
  if (!inProgress && total === 0) {
    return (
      <ConfirmTransferModal>
        <Title>Processing Transfer...</Title>
        <Loader />
      </ConfirmTransferModal>
    );
  }

  // Batch mode - show detailed progress
  const completedCount = successful + failed;
  const progressPercentage = total > 0 ? Math.round((completedCount / total) * 100) : 0;

  return (
    <ConfirmTransferModal>
      <Title>Processing Batches</Title>

      <ProgressContainer>
        <p style={{ marginBottom: '0.5rem' }}>
          Submitted: {submitted} / {total} batches
        </p>
        <div style={{
          width: '100%',
          height: '20px',
          backgroundColor: '#e0e0e0',
          borderRadius: '10px',
          overflow: 'hidden',
          marginBottom: '0.5rem'
        }}>
          <div style={{
            height: '100%',
            width: `${progressPercentage}%`,
            backgroundColor: '#4CAF50',
            transition: 'width 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '12px',
            fontWeight: 'bold'
          }}>
            {progressPercentage > 10 && `${progressPercentage}%`}
          </div>
        </div>
        {progressPercentage <= 10 && (
          <p style={{ fontSize: '12px', textAlign: 'center' }}>
            {progressPercentage}%
          </p>
        )}
      </ProgressContainer>

      <BatchStatus>
        <StatusItem success>
          ✓ Successful: {successful}
        </StatusItem>
        <StatusItem error>
          ✗ Failed: {failed}
        </StatusItem>
      </BatchStatus>

      {inProgress && <Loader />}

      {/* Show recent results */}
      {results && results.length > 0 && (
        <ResultsList>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem', fontSize: '14px' }}>
            Recent Activity:
          </p>
          {results.slice(-5).reverse().map((result, idx) => (
            <ResultItem key={idx} success={result.status === 'success'}>
              Batch {result.batchNumber}: {result.status === 'success' ? '✓ Success' : `✗ ${result.error}`}
            </ResultItem>
          ))}
        </ResultsList>
      )}
    </ConfirmTransferModal>
  );
};
